import React from 'react';
import HomeLayout from '../../../components/Layout/HomeLayout';
import NotFound from '../../notFound/NotFound';
import Page from '../../../components/Page';
import fetch from '../../../core/fetch';
import AboutStaticPage from './AboutStaticPage';

const query = `query getEditStaticPage ($id: Int!) {
  getEditStaticPage (id: $id) {
      id
      pageName
      content
      metaTitle
      metaDescription
      createdAt
      isEnable
  }
}`;

export default async function action({ locale }) {

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: query,
      variables: { id: 1 },
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();
  let isEnable = data?.getEditStaticPage?.isEnable;
  if (isEnable !== undefined && isEnable == false) {
    return {
      title: data?.getEditStaticPage?.metaTitle,
      description: data?.getEditStaticPage?.metaDescription,
      component: <HomeLayout><NotFound /> </HomeLayout>,
    };
  }

  return {
    title: data?.getEditStaticPage?.metaTitle,
    description: data?.getEditStaticPage?.metaDescription,
    /* component: <Layout><Page html={data?.getEditStaticPage?.content} title={data?.getEditStaticPage?.metaTitle} /></Layout>, */
    component: <HomeLayout whiteHeader><AboutStaticPage title={data?.getEditStaticPage?.metaTitle} /></HomeLayout>
  };

}
